export const convertStringToDom = (htmlString) => document.createRange().createContextualFragment(htmlString);
